import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';

function* newsListGet(action) {
  const {res} = yield call(function(payload) {
    var params = new URLSearchParams();
    return axios.post(config.apiUri + "newsListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "NEWS_LIST_SET",
        payload: {
          list: res.data.list,
        },
      });
    }
  }
}



const saga = [
  takeLatest('NEWS_LIST_GET', newsListGet),
];

export default saga;
